import { render, staticRenderFns } from "./tabulator.vue?vue&type=template&id=4efed154&"
import script from "./tabulator.vue?vue&type=script&lang=js&"
export * from "./tabulator.vue?vue&type=script&lang=js&"
import style0 from "./tabulator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabulator.vue"
export default component.exports